"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var entity_form_resolver_service_1 = require("@synisys/idm-portfolio-control/app/controls/portfolio/entity-form-resolver.service");
var form_resolution_service_1 = require("../../../../shared/services/api/form-resolution.service");
var Observable_1 = require("rxjs/Observable");
var router_1 = require("@angular/router");
var idm_form_management_ui_1 = require("@synisys/idm-form-management-ui");
var operators_1 = require("rxjs/operators");
var root_category_summary_page_config_service_1 = require("../../../../shared/services/api/summary-pages/root-category-summary-page-config-service");
var dynamic_navigation_helper_1 = require("../../common/utils/dynamic-navigation-helper");
var url_and_query_params_1 = require("../../../../shared/utils/url-and-query-params");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var root_category_provider_service_1 = require("../../../../shared/services/api/root-category-provider.service");
var BasePortfolioFormResolverService = /** @class */ (function () {
    function BasePortfolioFormResolverService(formResolutionService, formManagementService, rootCategorySummaryPageConfigService, rootCategoryProviderService, route) {
        this.formResolutionService = formResolutionService;
        this.formManagementService = formManagementService;
        this.rootCategorySummaryPageConfigService = rootCategorySummaryPageConfigService;
        this.rootCategoryProviderService = rootCategoryProviderService;
        this.route = route;
    }
    BasePortfolioFormResolverService.prototype.getFormProperties = function (row, columnSystemName) {
        var _this = this;
        var queryParams = Object.assign({}, this.route.snapshot.queryParams);
        var rootCategoryId = dynamic_navigation_helper_1.getPropertyFromUrl(url_and_query_params_1.UrlAndQueryParams.rootCategoryId, this.route);
        var categoryId = dynamic_navigation_helper_1.getPropertyFromUrl(url_and_query_params_1.UrlAndQueryParams.categoryId, this.route) || rootCategoryId;
        // when category is root open overview form, otherwise open typed form
        return this.rootCategoryProviderService.getRootCategoryId(categoryId).pipe(operators_1.switchMap(function (rootCategory) {
            if (rootCategory === categoryId) {
                return _this.getRootCategoryFormId(rootCategoryId).pipe(operators_1.map(function (formId) { return new entity_form_resolver_service_1.FormProperties(formId, rootCategoryId + "Overview", row.entityInstanceId, rootCategoryId, queryParams); }));
            }
            else {
                return _this.formResolutionService.getEntityFormProperties(categoryId, row.entityInstanceId, row.entity).pipe(operators_1.map(function (formProperties) {
                    return new entity_form_resolver_service_1.FormProperties(formProperties.viewFormId, formProperties.viewFormName, row.entityInstanceId, categoryId, queryParams);
                }));
            }
        }));
    };
    BasePortfolioFormResolverService.prototype.getRootCategoryFormId = function (rootCategoryId) {
        var _this = this;
        return this.rootCategorySummaryPageConfigService.getConfigByRootCategory(rootCategoryId).pipe(operators_1.switchMap(function (config) {
            if (config && config.formId) {
                return Observable_1.Observable.of(+config.formId);
            }
            else {
                return _this.formManagementService.loadFormsByCategoryAndType(rootCategoryId, idm_dynamic_layout_interpreter_1.FormType.VIEW).pipe(operators_1.map(function (forms) { return forms[0].id; }));
            }
        }), operators_1.shareReplay(1));
    };
    BasePortfolioFormResolverService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [form_resolution_service_1.FormResolutionService,
            idm_form_management_ui_1.FormManagementService,
            root_category_summary_page_config_service_1.RootCategorySummaryPageConfigService,
            root_category_provider_service_1.RootCategoryProviderService,
            router_1.ActivatedRoute])
    ], BasePortfolioFormResolverService);
    return BasePortfolioFormResolverService;
}());
exports.BasePortfolioFormResolverService = BasePortfolioFormResolverService;
//# sourceMappingURL=base-portfolio-form-resolver.service.js.map